const accountabilityStatement = () => {
  window.open(
    'https://drive.google.com/file/d/1GZYrD9Oa7tMHbtRcspp-1J9WLLCID_rO/view?usp=sharing',
  )
}

export default accountabilityStatement
